import ArticleSideBar from "../../articles/ArticleSideBar"
import {Box, IconButton, Tooltip} from "@mui/material"
import {ArchiveOutlined, OpenInNew, Unarchive, Visibility} from "@mui/icons-material"
import {useMemo} from "react"
import {useDispatch, useSelector} from "react-redux"
import {
	markAsArchived,
	markAsUnarchived,
	markNotificationsAsRead, NotificationType,
	selectCurrentPanelView, setSharedArticlesWorkspaceId, setSwitchWorkspaceModal, setTargetWorkspace
} from "../../../reducers/notificationsSlice"
import {fetchArticles} from "../../../reducers/notificationPanelArticlesSlice"
import {useSnackbar} from "notistack"
import {useWorkspaceContext} from "../../../pages/Dashboard"

export default function NotificationSidebarButtons({sharedCitationObject, setIsFadingOut }) {
	const dispatch = useDispatch()
	const { workspaceId } = useWorkspaceContext()
	const isSentView = useSelector((state) => selectCurrentPanelView(state, workspaceId)) === 2
	const { enqueueSnackbar } = useSnackbar()

	const fadeOut = () => {
		setIsFadingOut(true)
		setTimeout(() => {
			handleArchive()
		}, 300)
	}

	const handleArchive = () => {
		if (!sharedCitationObject.isArchived) {
			dispatch(markAsArchived(sharedCitationObject.notificationId))
		} else {
			dispatch(markAsUnarchived(sharedCitationObject.notificationId))
		}
		setIsFadingOut(false)
	}
	// computed property that sets the title value of the tooltip. useMemo likely overkill?
	const leftButtonToolTipTitle = useMemo(() => {
		if(sharedCitationObject.type === "workspace_add") {
			return "Switch to the invited workspace"
		}

		if(sharedCitationObject.type === "article_share") {
			return "Review the articles shared with you"
		}
	}, [])

	const handleNotificationClick = async () => {
		if (sharedCitationObject.type === NotificationType.ARTICLE_SHARE) {
			dispatch(setTargetWorkspace({targetWorkspaceId: null, workspaceId}))
			const fetchResult = await dispatch(fetchArticles({ workspaceId, sharedArticleArray: sharedCitationObject.articles, enqueueSnackbar, sharedWorkspaceId: sharedCitationObject.sharedWorkspaceId  }))

			if (fetchResult.payload) { // Check if the payload exists, indicating success.
				dispatch(markNotificationsAsRead(sharedCitationObject.notificationId))
				if(fetchResult.payload.sharedWorkspaceId){
					dispatch(setSharedArticlesWorkspaceId({sharedId: fetchResult.payload.sharedWorkspaceId, workspaceId: fetchResult.payload.workspaceId}))
				}
			}
		}
		if (sharedCitationObject.type === NotificationType.WORKSPACE_ADD) {
			dispatch(markNotificationsAsRead(sharedCitationObject.notificationId))
			if (sharedCitationObject.sendingWorkspace.id === workspaceId) {
				enqueueSnackbar(
					`You are already in the ${sharedCitationObject.sendingWorkspace.title} workspace`,
					{
						variant: "info",
						autoHideDuration: 3000,
					}
				)
			} else {
				dispatch(setTargetWorkspace({targetWorkspaceId: sharedCitationObject.sendingWorkspace, workspaceId}))
				dispatch(setSwitchWorkspaceModal(true))
			}
		}

	}

	const rightButtonToolTipTitle = useMemo(() => {
		if(sharedCitationObject.isArchived === false) {
			return "Archive this notification"
		}

		if(sharedCitationObject.isArchived === true) {
			return "Unarchive this notification and move it to inbox"
		}
	}, [])
	return (
		<Box
			sx={{
				display: "flex",
				alignSelf: "stretch",
				maxWidth: "100px",
				//flex: "1 0 80px",
			}}
		>
			{ ["workspace_add", "article_share"].includes(sharedCitationObject.type) && (
				<Tooltip title={leftButtonToolTipTitle} placement="left">
					<ArticleSideBar
						variant={sharedCitationObject.isRead ? "notificationActionSeen" : "notificationAction"}
					>
						<IconButton
							onClick={handleNotificationClick}
						>
							{ sharedCitationObject.type === "workspace_add" && (
								<OpenInNew />
							)}
							{ sharedCitationObject.type === "article_share" && (
								<Visibility />
							)}
						</IconButton>
					</ArticleSideBar>
				</Tooltip>
			)}
			{ !isSentView &&
				<Tooltip title={rightButtonToolTipTitle} placement="right">
					<ArticleSideBar
						variant={"notificationArchive"}
					>
						<IconButton
							onClick={fadeOut}
						>
							{ sharedCitationObject.isArchived === false ? <ArchiveOutlined /> : <Unarchive /> }
						</IconButton>
					</ArticleSideBar>
				</Tooltip>
			}
		</Box>
	)
}